import SparkingFill from '@assets/agents/sparkling-fill.svg?react';
import SummaryIcon from '@assets/agents/summary-icon.svg?react';
import palette from '@lib/core/src/theme/palette';
import { Box, Stack, Typography } from '@mui/material';

import { DataSourcesContainer } from './AgentConfigStyles';
import { AgentConfigType } from './AgentsListConfig';

export const AgentConfigOverview = ({
  name,
  description,
  dataSources
}: {
  name: string;
  description: string;
  dataSources: AgentConfigType['dataSources'];
}) => (
  <Stack gap={'24px'}>
    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: '24px' }}>
      <Box sx={{ position: 'relative' }}>
        <SparkingFill
          style={{
            position: 'absolute',
            right: '-5px',
            background: '#fff',
            borderRadius: '50%',
            top: '-5px'
          }}
        />
        <SummaryIcon />
      </Box>
      <Box>
        <Typography sx={{ color: palette.black, fontSize: '18px', fontWeight: 600 }}>
          {name}
        </Typography>
        <Typography sx={{ color: palette.grey[500], fontSize: '13px', fontWeight: 500 }}>
          {description}
        </Typography>
      </Box>
    </Box>
    <DataSourcesContainer>
      <Typography sx={{ color: palette.grey[500], fontSize: 11 }}>Data sources</Typography>
      {dataSources.map(({ name, icon }) => (
        <Typography
          key={name}
          sx={{
            color: palette.black,
            fontSize: 12,
            display: 'flex',
            gap: '6px',
            alignItems: 'center'
          }}
        >
          {icon}
          {name}
        </Typography>
      ))}
    </DataSourcesContainer>
  </Stack>
);
